<template>
  <body class="ui_index modal-open">
  <div class="overlay"></div>
  <div class="modal_fixed">
    <div class="how_to_win_box modal_cont" id="how_to_win_modal">
      <img src="/static/images/store/icon-close-back-popup.svg" class="btn_close">

      <h1>{{ titleText }}</h1>
      <img :src="prize.imgUrl" class="win_box_img">
      <h2>{{ getTranslations.visitor_prizes_how_win }}</h2>
      <p>
        {{ getTranslations.visitor_how_to_win_text }}
      </p>
      <h2>{{ getTranslations.visitor_how_to_win_criteria }}</h2>
      <p>
        {{ getTranslations.visitor_how_to_win_criteria_text }}
      </p>
    </div>
  </div>
  </body>
</template>

<script>
  //
import { mapGetters, mapState, mapMutations } from 'vuex';


export default {
  name: 'Howtowin',
  data() {
    return {
      titleText: '',
      prize: {},
      showSimpleRegistrationModal: false,
    };
  },
  created() {
    if (this.howItWinType === 3) {
      this.titleText = this.getTranslations.visitor_prizes_weekly_prizes;
      this.prize = this.getWeeklyPrize;
    } else if (this.howItWinType === 2) {
      this.prize = this.getMonthlyPrize;
      this.titleText = this.getTranslations.visitor_prizes_monthly_prizes;
    } else {
      this.titleText = this.getTranslations.visitor_prizes_grand_prizes;
      this.prize = this.getGrandPrize;
    }
    this.showModal();
  },
  computed: {
    ...mapState('common', [
      'howItWinType',
    ]),
    ...mapGetters('profile', [
      'getGrandPrize',
      'getWeeklyPrize',
      'getMonthlyPrize',
      'getCarouselPrizes',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('common', [
      'getRefUrl',
      'getClickId',
      'getCampaignId',
      'getPublisherId',
    ]),
  },
  methods: {
    ...mapMutations('game', [
      'storeRegistrationPoints',
    ]),
    ...mapMutations('common', [
      'setFreeTrialUserPrice',
    ]),
    showModal() {
      /* eslint-disable */
      const vm = this;
      this.$nextTick(() => {
        // open modal
        $('.how_to_win_box,.overlay').fadeIn(200);
        // show/hide modal
        $('.btn_close, .overlay').click(function () {
          vm.$emit('close');
          $('#how_to_win_modal').fadeOut();
        });
      });
      /* eslint-enable */
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/Howtowin.vue